import React, { useState, useEffect } from 'react';
import './CaptionDisplay.css';

/**
 * Caption Display Component
 * Shows real-time captions above the video grid
 * 
 * Props:
 * - isActive: boolean - Whether transcription is running
 * - currentCaption: string - Current interim caption text
 * - speaker: string - Name of current speaker
 * - language: string - Current language
 */
const CaptionDisplay = ({ isActive, currentCaption, speaker, language = 'en-US', isVisible = true }) => {
  const [visibleCaption, setVisibleCaption] = useState('');
  const [isFading, setIsFading] = useState(false);

  useEffect(() => {
    if (currentCaption) {
      setVisibleCaption(currentCaption);
      setIsFading(false);

      // Auto-fade out after 3 seconds if no new caption
      const fadeTimer = setTimeout(() => {
        setIsFading(true);
        setTimeout(() => {
          setVisibleCaption('');
          setIsFading(false);
        }, 500);
      }, 3000);

      return () => clearTimeout(fadeTimer);
    }
  }, [currentCaption]);

  if (!isActive || !isVisible) {
    return null; // Don't show if transcription not active or hidden
  }

  return (
    <div className={`caption-display ${isFading ? 'fading' : ''}`}>
      <div className="caption-container">
        <div className="caption-speaker">{speaker}</div>
        <div className="caption-text">{visibleCaption || '…'}</div>
        <div className="caption-language">{language}</div>
      </div>
    </div>
  );
};

export default CaptionDisplay;
